import { render } from "./showProductsComponent.vue?vue&type=template&id=dc6cdc94"
import script from "./showProductsComponent.vue?vue&type=script&lang=js"
export * from "./showProductsComponent.vue?vue&type=script&lang=js"

import "./showProductsComponent.vue?vue&type=style&index=0&id=dc6cdc94&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/showProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc6cdc94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc6cdc94', __exports__)) {
    api.reload('dc6cdc94', __exports__)
  }
  
  module.hot.accept("./showProductsComponent.vue?vue&type=template&id=dc6cdc94", () => {
    api.rerender('dc6cdc94', render)
  })

}


export default __exports__